import { ref, onBeforeUnmount } from "vue";
import useKeyboard from "@/composables/useKeyboard";

export default function useKeyboardInput(startValue = "", opts = {}) {

    const { keyboard, registerHandler, setActiveInputName, setInput, showKeyboard, hideKeyboard } = useKeyboard();

    const text = ref(startValue);

    const inputName = opts.inputName ?? `input_${Math.random().toString(36).slice(2,9)}`;

    const handler = (val) => {
        text.value = val;
        onTextChangeHook(val)
    };

    const onFocus = (event) => {
        registerHandler(handler);
        setActiveInputName(inputName);
        showKeyboard();

        // push current local value in Keyboard
        if (keyboard.value) setInput(text.value, inputName);

        // native input → virtual keyboard sync
        if (event && event.target) {
            event.target.addEventListener("input", onNativeInput);
        }
    };

    const onNativeInput = (ev) => {
        const v = ev.target.value;
        if (keyboard.value) setInput(v, inputName);
        onTextChangeHook(v)
    };

    const onBlur = (event) => {
        registerHandler(()=>{});
        hideKeyboard();
        if (event && event.target) {
            event.target.removeEventListener("input", onNativeInput);
        }
    };

    const clear = () => {
        text.value = "";
        if (keyboard.value) setInput("", inputName);
        onTextChangeHook("");
    };

    let onTextChangeHook = () => {};

    let onTextChange = (callback) => {
        onTextChangeHook = callback
    }

    onBeforeUnmount(() => {
        registerHandler(()=>{});
    });

    return {
        text,
        onFocus,
        onBlur,
        clear,
        inputName,
        onTextChange,
    };
}
